import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

interface AccountingFeature {
  title: string;
  image: string;
  points: string[];
}

@Component({
  selector: 'app-accounting-features',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accounting-features.html',
  styleUrls: ['./accounting-features.css'],
})
export class AccountingFeaturesComponent {
  readonly features: AccountingFeature[] = [
    {
      title: 'Ledgers',
      image: 'images/modules/ledgers.PNG',
      points: ['Multi-currency ledgers', 'Own fiscal calendar', 'Default & active status'],
    },
    {
      title: 'Chart of Accounts',
      image: 'images/modules/charts.PNG',
      points: ['179+ ready-made accounts', 'Fully categorized', 'Posting & control settings'],
    },
    {
      title: 'Journal Entries',
      image: 'images/modules/journel.PNG',
      points: ['Manual & system entries', 'Debit/credit balancing', 'Draft to posted status'],
    },
    {
      title: 'Fiscal Calendar',
      image: 'images/modules/calender.PNG',
      points: ['Open, close & lock years', 'Transaction-aware locking', 'Reopen anytime'],
    },
    {
      title: 'Account Categories',
      image: 'images/modules/categories.PNG',
      points: ['Assets, liabilities & equity', 'Revenue & expense grouping', 'Debit/credit balances'],
    },
    {
      title: 'Dimensions',
      image: 'images/modules/dimentions.PNG',
      points: ['Department & location tags', 'Fully custom dimensions', 'Slice any report by tag'],
    },
    {
      title: 'Financial Reports',
      image: 'images/modules/reports.PNG',
      points: ['Trial balance & balance sheet', 'P&L & cash flow', 'Full audit trail'],
    },
    {
      title: 'Tax Codes',
      image: 'images/modules/tax.PNG',
      points: ['Configurable tax rates', 'Recoverable vs non-recoverable', 'Applied automatically'],
    },
  ];
}
